import React, { Component, lazy, Suspense } from 'react';
import { createHashHistory } from 'history';
import { Switch, Redirect, Route } from "react-router-dom";
import Auth from "../../../../Layout/Auth";
const ChatHistoryPage = lazy(() => import('../Pages/ChatHistoryPage'))
class ChatRoute extends Component {
    render() {
        const history = createHashHistory();
        return (

            <Switch>
                <Route
                    exact
                    path="/:lng/chat"
                    render={() => (
                        <Auth history={history} allowedRoles={['app_admin', 'admin', 'user', 'staff']}>
                            <Suspense fallback={<Loading />}>
                                <ChatHistoryPage history={history} location={location} />
                            </Suspense>

                        </Auth>
                    )}
                />
            </Switch>
        );
    }
}
export default ChatRoute;

function Loading() {
    return (
      <>
        <div className="wrapper">
          <span>Loading...</span>
        </div>
      </>
    );
}
